import React from 'react';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {Breadcrumbs, Container, Link, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import BookingList from "../../components/GuestInfo/BookingList/BookingList";

/*const useStyles = makeStyles((theme) => ({
    banner: {
        backgroundColor: theme.palette.lightGray.main,
        marginTop: '50px',
        padding: '10px 0'
    },
}));*/

const MyBookingsPage = () => {
    // const classes = useStyles();

    return (
        <>
            <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Typography color="text.primary">
                        Bookings
                    </Typography>
                </Breadcrumbs>
            </GuestBar>
            {/*<Container className={classes.banner}>
                <h4 style={{fontWeight: '600'}}>
                    Special Offer banner
                </h4>
            </Container>*/}
            <BookingList />
        </>
    );
};

export default MyBookingsPage;